import React from 'react';

import { Link } from '@atoms';

import s from './styles.module.less';

const TableTitleColumn = ({ children, url, to }) => (
  <>
    <Link to={to} className={s.title}>
      {children}
    </Link>
    {url && (
      <>
        <br />
        <a href={url}>{url}</a>
      </>
    )}
  </>
);

export default TableTitleColumn;
